import React, { useEffect, useState } from 'react';
import {
  Card, Button, Dialog, DialogContent, useMediaQuery, useTheme
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Form, InputGroup } from 'react-bootstrap';
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import toast, { Toaster } from "react-hot-toast";
import Swal from 'sweetalert2';

// GraphQL Queries and Mutations




export default function SalesPage() {
  const [open, setOpen] = useState(false);
  const [teamData, setTeamData] = useState([
    { _id: "1", name: "bhabesh", email: "bhabesh09@gmail.com" },
    { _id: "2", name: "manas", email: "manas09@gmail.com" },
    { _id: "3", name: "biju", email: "biju@gmail.com" },
  ]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState("Yes");
  const [editingTeamId, setEditingTeamId] = useState(null); // Added for update

  const theme = useTheme(); 
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = (member = null) => {
    setOpen(true);
    if (member) {
      setEditingTeamId(member._id);
      setName(member.name);
      setEmail(member.email);
      setPassword("");
      return;
    }

    setEditingTeamId(null);
    setName("");
    setEmail("");
    setPassword("");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    if (!name.trim() || !email.trim()) {
      toast.error("Name and email are required");
      return;
    }

    if (editingTeamId) {
      setTeamData((prev) =>
        prev.map((item) =>
          item._id === editingTeamId ? { ...item, name: name.trim(), email: email.trim() } : item
        )
      );
      toast.success("Sale updated");
    } else {
      setTeamData((prev) => [
        ...prev,
        { _id: Date.now().toString(), name: name.trim(), email: email.trim() },
      ]);
      toast.success("Sale added");
    }

    handleClose();
  };

  const handleDelete = (id) => {
    setTeamData((prev) => prev.filter((item) => item._id !== id));
    toast.success("Sale deleted");
  };

  // Fetch teams query

  
   


  

  // Fetch team members
 

  

 
  //  create team
 

 
  return (
    <div className="container px-4 py-4">
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h5 style={{ fontWeight: "bold", fontFamily: "sans-serif" }}>All SALES </h5>
        </div>
        <div>
          <button type="button" className="btn text-white" style={{ background: " #A1368B" }} onClick={() => handleClickOpen()}>ADD SALES</button>
        </div>

        <Dialog
          fullScreen={fullScreen}
          open={open}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <div className='d-flex flex-column justify-content-end'>
              <label htmlFor="salesName">Name</label>
              <InputGroup className="mb-3" style={{ width: 500, maxWidth: '100%' }} size="lg">
                <Form.Control
                  id="salesName"
                  type="text"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </InputGroup>

              <label htmlFor="salesEmail">Email Id:</label>
              <InputGroup className="mb-3" style={{ width: 500, maxWidth: '100%' }} size="lg">
                <Form.Control
                  id="salesEmail"
                  type="text"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </InputGroup>

              <div className='d-flex flex-row mt-4 justify-content-end'>
                <Button className='text-white bg-danger fw-bold' onClick={handleClose}>Cancel</Button>
                <Button
                  style={{ background: "#A1368B", color: "white", marginLeft: "20px", fontWeight: "bold" }}
                  onClick={handleSubmit}
                >
                  {editingTeamId ? "Update" : "Create"}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
     
     
      </div>

      <Card className='mt-4' style={{ border: "2px solid #4F5B66 " }}>  
        <table className="table table-striped table-bordered" style={{ width: '100%', textAlign: 'center' }}>
          <thead className="thead-light">     
            <tr>
              <th scope="col"> Name</th>
              <th scope="col">Email</th>
              <th scope="col">Action</th>
            </tr>
          </thead> 

          <tbody>
            
             
            {teamData.length > 0 ? (
              teamData.map((team) => (
                <tr key={team._id}>
                  <td>{team.name}</td>
                  <td>{team.email}</td> 
                  <td>                   
                    <EditIcon style={{ color: "black", cursor: "pointer", marginRight: "10px" }} onClick={() => handleClickOpen(team)} />
                    <DeleteIcon style={{ color: "red", cursor: "pointer" }} onClick={() => handleDelete(team._id)} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3}>No sales found</td>
              </tr>
            )}
                      
          </tbody>
        </table>
      </Card>
      <Toaster />
    </div>
  );
}
